/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {PermissionId} from "../../models/users/Permission";
import {UserAccountType} from "../../models/users/User";
import {hasPermissions, hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const thirdPartyCompaniesRoutes = [
  {
    path: "third-party-companies",
    canActivateChild: [
      isLoggedIn,
      hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce),
    ],
    children: [
      {
        path: "",
        loadComponent: () => import("./list/third-party-companies-list").then(m => m.ThirdPartyCompaniesList),
      },
      {
        path: "create",
        canActivate: [hasPermissions(PermissionId.ManageThirdPartyCompany)],
        loadComponent: () => import("./form/third-party-company-form").then(m => m.ThirdPartyCompanyForm),
      },
      {
        path: ":thirdPartyCompanyId",
        canActivate: [hasPermissions(PermissionId.ManageThirdPartyCompany)],
        loadComponent: () => import("./form/third-party-company-form").then(m => m.ThirdPartyCompanyForm),
      },
    ],
  },
] as const satisfies Routes;
